import { AutoMap } from "@automapper/classes";

export class Pompe {
    @AutoMap()
    Reference!: string;

    Bluetooth!: boolean;
    @AutoMap()
    ElectriciteAccessible: boolean = true;
    @AutoMap()
    DebitInitial!: number;
    @AutoMap()
    DebitFinal!: number;
    @AutoMap()
    CompteurVolInitial!: number;
    @AutoMap()
    CompteurVolFinal!: number;
    @AutoMap()
    CompteurHoraireInitial!: number;
    @AutoMap()
    CompteurHoraireFinal!: number;

    private _CompteurHoraireInitialHeures: number | undefined;
    get CompteurHoraireInitialHeures() {
        return this._CompteurHoraireInitialHeures;
    }

    set CompteurHoraireInitialHeures(hours: number | undefined) {
        this._CompteurHoraireInitialHeures = hours;
        if (hours !== undefined) {
            this.CompteurHoraireInitial = (this.CompteurHoraireInitialHeures ?? 0) * 60 + (this.CompteurHoraireInitialMinutes ?? 0);
        }
    }

    private _CompteurHoraireInitialMinutes: number | undefined;
    get CompteurHoraireInitialMinutes() {
        return this._CompteurHoraireInitialMinutes;
    }

    set CompteurHoraireInitialMinutes(mins: number | undefined) {
        this._CompteurHoraireInitialMinutes = mins;
        if (mins !== undefined)
            this.CompteurHoraireInitial = (this.CompteurHoraireInitialHeures ?? 0) * 60 + (this.CompteurHoraireInitialMinutes ?? 0);
    }

    private _CompteurHoraireFinalHeures: number | undefined;
    get CompteurHoraireFinalHeures() {
        return this._CompteurHoraireFinalHeures;
    }

    set CompteurHoraireFinalHeures(hours: number | undefined) {
        this._CompteurHoraireFinalHeures = hours;
        if (hours !== undefined)
            this.CompteurHoraireFinal = (this.CompteurHoraireFinalHeures ?? 0) * 60 + (this.CompteurHoraireFinalMinutes ?? 0);
    }

    private _CompteurHoraireFinalMinutes?: number | undefined;
    get CompteurHoraireFinalMinutes() {
        return this._CompteurHoraireFinalMinutes;
    }

    set CompteurHoraireFinalMinutes(mins: number | undefined) {
        this._CompteurHoraireFinalMinutes = mins;
        if (mins !== undefined)
            this.CompteurHoraireFinal = (this.CompteurHoraireFinalHeures ?? 0) * 60 + (this.CompteurHoraireFinalMinutes ?? 0);
    }

    public constructor(init?: Partial<Pompe>) {
        Object.assign(this, init);
    }
}